import { render } from "./px-questionary-numeric.vue?vue&type=template&id=bee10fca&scoped=true&ts=true"
import script from "./px-questionary-numeric.vue?vue&type=script&lang=ts"
export * from "./px-questionary-numeric.vue?vue&type=script&lang=ts"

import "./px-questionary-numeric.vue?vue&type=style&index=0&id=bee10fca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bee10fca"]])

export default __exports__